import React, { useCallback } from 'react'
import { useTranslation } from 'react-i18next'

import Step from '../../../../../../../../features/components/Forms/StepForm/Step'
import RadioBlock from '../../../../../../../../components/Form/RadioBlock'
import InlineField from '../../../../../../../../components/Form/InlineField'
import CpaAdvancedSettings from '../CpaAdvancedSettings'

import {
  FREQUENCY_DAYS,
  FREQUENCY_IMPRESSIONS,
  FREQUENCY_OPTION,
  FREQUENCY_OPTION_NO_MORE_THAN_3_TIMES_EVERY_7_DAYS,
  FREQUENCY_OPTION_NO_MORE_THAN_ONCE_A_DAY
} from '../../../../../../../ReusableFormFields/FrequencyFields/fields'
import { OPTION_CUSTOM } from '../../../../../../../../constants/forms'

const stepFields = [FREQUENCY_OPTION, FREQUENCY_IMPRESSIONS, FREQUENCY_DAYS]

const FrequencyStep = ({ formik, handleStepChange, campaignObjective, showBidField }) => {
  const { t } = useTranslation()

  const { values, setFieldValue, errors, touched } = formik

  const impressionError = errors[FREQUENCY_IMPRESSIONS]
  const daysError = errors[FREQUENCY_DAYS]

  const isImpressionsTouched = touched[FREQUENCY_IMPRESSIONS]
  const isDaysTouched = touched[FREQUENCY_DAYS]

  const isTouched = isImpressionsTouched || isDaysTouched
  const error = impressionError || daysError

  const handleContinue = useCallback(() => {
    handleStepChange(stepFields)
  }, [handleStepChange])

  return (
    <Step stepTitle="Would you like to set a frequency cap?" handleContinue={handleContinue}>
      <RadioBlock
        setFieldValue={setFieldValue}
        id="radio_frequency_option_frequency_custom"
        name={FREQUENCY_OPTION}
        value={OPTION_CUSTOM}
        selectedValue={values[FREQUENCY_OPTION]}
        error={error}
        touched={isTouched}
        label={t('Custom frequency cap')}
      >
        {t('Limit to')}
        <InlineField formik={formik} name={FREQUENCY_IMPRESSIONS} type="number" />
        {t('exposures per')}
        <InlineField formik={formik} name={FREQUENCY_DAYS} type="number" />
        {t('day(s)')}
      </RadioBlock>
      <RadioBlock
        setFieldValue={setFieldValue}
        id={FREQUENCY_OPTION_NO_MORE_THAN_3_TIMES_EVERY_7_DAYS}
        name={FREQUENCY_OPTION}
        value={FREQUENCY_OPTION_NO_MORE_THAN_3_TIMES_EVERY_7_DAYS}
        selectedValue={values[FREQUENCY_OPTION]}
        label={t('Show ads no more than 3 times every 7 days')}
      />
      <RadioBlock
        setFieldValue={setFieldValue}
        id={FREQUENCY_OPTION_NO_MORE_THAN_ONCE_A_DAY}
        name={FREQUENCY_OPTION}
        value={FREQUENCY_OPTION_NO_MORE_THAN_ONCE_A_DAY}
        selectedValue={values[FREQUENCY_OPTION]}
        label={t('Show no more than once a day')}
      />

      {showBidField && (
        <CpaAdvancedSettings formik={formik} campaignObjective={campaignObjective} showBidField={showBidField} />
      )}
    </Step>
  )
}

export default FrequencyStep
